import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      groups_list: {
        header: 'HEADER',
        create_btn: 'CREATE',
        remove_modal: {
          title: 'TITLE',
          delete_question: 'MESSAGE',
          answer_yes: 'YES',
          answer_no: 'NO',
        },
      },
    },
  }));
}
